import { ICityLiteAsset } from "models/Assets/ICityAsset";
import { useGetCityAsset } from "contexts/AssetsContext";
import { useGetRoutesObjectsIds } from "contexts/RoutesObjectContext";

type hookReturnValues = ICityLiteAsset;

export default function useGetRouteCity(): hookReturnValues {
  const city = useGetCityAsset(useGetRoutesObjectsIds().cityId);

  return city;
}
